var CONFUSEDCMS = CONFUSEDCMS || {},
    CSSCONSTANTS = CSSCONSTANTS || {};

(function ($) {

    CONFUSEDCMS.expandingBands = function () {
   
        var $expandingBandToggleContainer = $('.band-toggle-container');
        var $expandingBandToggle = $expandingBandToggleContainer.find('.band-toggle');
        var $expandingBandToggleSection = $expandingBandToggleContainer.next('.band--toggle-section');

        $expandingBandToggle.on('click',function (e) {
            e.preventDefault();
            if($expandingBandToggle.hasClass('band-toggle--open')) {
                $expandingBandToggle.removeClass('band-toggle--open');
                $expandingBandToggle.addClass('band-toggle--closed');
                $expandingBandToggleSection.slideUp();
                $expandingBandToggleSection.addClass('band--toggle-section--closed');
            }
            else {
                $expandingBandToggle.removeClass('band-toggle--closed');
                $expandingBandToggle.addClass('band-toggle--open');
                $expandingBandToggleSection.slideDown();
                $expandingBandToggleSection.removeClass('band--toggle-section--closed');
            }    
        });
    };


})(window.jQuery);


